// Centralized key-value mapping

const allSortingValues = {
  recommended: "r",
  distanceFromHome: "dista",
  employmentRate: "empd",
  entryReqsHighest: "entd",
  entryReqsLowest: "enta",
  wuscaUniversityOfYear: "wuoy",
  wuscaCareerProspects: "wcp",
  wuscaFacilities: "wf",
  wuscaInternational: "wi",
  wuscaLecturersTeaching: "wltq",
  wuscaPostgraduate: "wpg",
  wuscaStudentLife: "wsl",
  wuscaStudentSupport: "wss",
  wuscaStudentsUnion: "wsu",
  wuscaUniversityHalls: "wuh",
  priceLowToHigh: "price_asc",
  ourTopPicks: "crh",
  aToZ: "ta",
  priceHighToLow: "price_desc",
  courseAToZ: "ta",
  courseZToA: "td",
  emptyValue: "",
} as const;

// Define filters by mapping labels to values
export const wuSortingFilter = {
  Recommended: allSortingValues.recommended,
  "Distance from home": allSortingValues.distanceFromHome,
  "Employment rate": allSortingValues.employmentRate,
  "Entry reqs - Highest": allSortingValues.entryReqsHighest,
  "Entry reqs - lowest": allSortingValues.entryReqsLowest,
} as const;

export const wuscaCategories = {
  "University of the Year ranking": allSortingValues.wuscaUniversityOfYear,
  "Career Prospects ranking": allSortingValues.wuscaCareerProspects,
  "Facilities ranking": allSortingValues.wuscaFacilities,
  "International ranking": allSortingValues.wuscaInternational,
  "Lecturers and Teaching Quality ranking":
    allSortingValues.wuscaLecturersTeaching,
  "Postgraduate ranking": allSortingValues.wuscaPostgraduate,
  "Student life ranking": allSortingValues.wuscaStudentLife,
  "Student support ranking": allSortingValues.wuscaStudentSupport,
  "Student's Union ranking": allSortingValues.wuscaStudentsUnion,
  "University Halls ranking": allSortingValues.wuscaUniversityHalls,
} as const;

export const pgsSortingFilter = {
  "Recommended (CPE logic)": allSortingValues.recommended,
  "Distance from home": allSortingValues.distanceFromHome,
  "Employment rate": allSortingValues.employmentRate,
  "WUSCA Postgraduate ranking": allSortingValues.wuscaPostgraduate,
  "Price (low to high)": allSortingValues.priceLowToHigh,
} as const;

export const prSortingFilter = {
  "Our top picks": allSortingValues.ourTopPicks,
  "Entry requirements": allSortingValues.entryReqsHighest,
  "Employment rate": allSortingValues.employmentRate,
  "A-Z": allSortingValues.aToZ,
} as const;

export const pgsPrSortingFilter = {
  "Most info": allSortingValues.emptyValue,
  "Course title (A-Z)": allSortingValues.courseAToZ,
  "Course title (Z-A)": allSortingValues.courseZToA,
  "Price (Low to High)": allSortingValues.priceLowToHigh,
  "Price (High to Low)": allSortingValues.priceHighToLow,
} as const;

export const ClickstreamConstants = {
  pageViewAction: "Engagement",
  clickAction: "Interaction",
  requestInfoInternalEvent: "EnquiryFormClicked",
  requestInfoExternalEvent: "EnquiryWebFormClicked",
  applyNowEvent: "ApplyNowClicked",
  prospectusExternalEvent: "RPWebFormClicked",
  digitalProspectusEvent: "DigitalProspectusRequestClicked",
  physicalProspetcusEvent: "ProspectusRequestClicked",
  applyNowCTA: "Apply now",
  requestInfoCTA: "Request info",
  getProspectusCTA: "Get prospectus",
  bookOpenDayCTA: "Book open day",
  bookEventCTA: "Book event",
  visitWebsiteCTA: "Visit website",
  callNowCTA: "Call now",
  sponsorListing: "Sponsor listing",
  similarcourseEvent: "Similarcourseclicked",
  courseyoumaylikeEvent: "courseyoumaylikeclicked",
  searchbarEvent: "Searchbarclicked",
  filterClickedEvent: "FilterClicked",
  filterCTATitle: "show all result",
  readAllReviewClick: "ReadReviewClicked",
  readFullReviewClick: "ReadfullReviewClicked",
  pageViewEvent: "PageViewed",
  clearingVisitWebsite: "ClearingVisitWebsite",
  visitWebsite: "VisitWebsite",
};

export const ScholarshipCardTitles = {
  levelOfStudy: "Level of study",
  eligibleSubjects: "Eligible subjects",
  nationality: "Nationality ",
  numberOfAwards: "Number of awards available",
  gender: "Gender",
  studyMode: "Study mode",
  deliveryMode: "Delivery mode",
  eligibilityIntake: "Eligibility intake",
  fundingType: "Funding type",
  amountValue: "Amount/Value:",
  coverage: "Coverage",
  selectionBasis: "Selection basis",
  selectionApproach: "Selection approach",
  otherSelectionCriteria: "Other selection criteria",
  applicationType: "Application type",
  applicationDeadline: "Application deadline:  ",
  requiredDocuments: "Required documents:",
  applicationMethod: "Application method:",
} as const;

export const ScholarshipSectionNames = {
  scholarshipOverview: "scholarshipOverview",
  eligibleCriteria: "eligibleCriteria",
  fundingDetails: "fundingDetails",
  selectionProcess: "selectionProcess",
  applicationProcess: "applicationProcess",
} as const;

export const ScholarshipCardIcons = {
  clock: "/static/assets/icons/scholarship/clock.svg",
  fileSearching: "/static/assets/icons/scholarship/file-searching.svg",
  nationalityWorld: "/static/assets/icons/scholarship/nationality-world.svg",
  awardsStar: "/static/assets/icons/scholarship/awards-star.svg",
  avatar: "/static/assets/icons/scholarship/avatar.svg",
  delivery: "/static/assets/icons/scholarship/delivery.svg",
  fundingCard: "/static/assets/icons/scholarship/funding-card.svg",
  marketArrow: "/static/assets/icons/scholarship/market-arrow.svg",
  homeCoverage: "/static/assets/icons/scholarship/home-coverage.svg",
  groupAvatar: "/static/assets/icons/scholarship/group-avatar.svg",
  circleSearch: "/static/assets/icons/scholarship/circle-search.svg",
  folder: "/static/assets/icons/scholarship/folder.svg",
  document: "/static/assets/icons/scholarship/document.svg",
  bulb: "/static/assets/icons/scholarship/bulb.svg",
} as const;

export const GAConstants = {
  pageview: "pageview",
  page_view: "page_view",
  track_kpi: "track_kpi",
  track_event: "track_event",
  revenue_kpi: "revenue_kpi",
  pageGrouping: {
    course_search: "course_search_pages",
    money_related: "money_and_its_related_pages",
    home_page: "home_page",
    insitution_related: "institution_related_pages",
    cpc_pages: "cpc_pages",
    clearing: "clearing_pages",
    scholarship_pages: "scholarship_pages",
    subjectguide_landing: "subjectguide_landing",
    subjectguide_details: "subjectguide_details",
    reviews_institution_page: "reviews_institution_page",
    advice_article_pages: "advice_article_pages",
  },
  subjectGuideDetailsPageName: "subject_guide_details",
  favourite: "favourite",
  unfavourite: "unfavourite",
  clearing: "clearing",
  in_year: "in_year",
  notApplicable: "na",
  review_click: "review_click",
  review_events: "review events",
};
